export default "__VITE_ASSET__DrMXrXma__"